"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reconnect_js_1 = require("reconnect.js");
/**
 * @param {typeFeatureOptions} featureOptions
 */
var init = function (_a) {
    var _b = _a.points, points = _b === void 0 ? {} : _b, _c = _a.coupon, coupon = _c === void 0 ? {} : _c, _d = _a.facebookPixel, facebookPixel = _d === void 0 ? null : _d, _e = _a.googleAnalytics, googleAnalytics = _e === void 0 ? null : _e;
    var FeatureOptionsOutlet = reconnect_js_1.getNewOutlet('FeatureOptions', {
        points: points,
        coupon: coupon,
        facebookPixel: facebookPixel,
        googleAnalytics: googleAnalytics,
    }, {
        autoDelete: false,
    });
    return FeatureOptionsOutlet.getValue();
};
exports.default = init;
